import React, { useEffect, useMemo, useState } from 'react';
import { Card, Select, Typography } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipePipesizeCreate from './QaqcPipePipesizeCreate';
import type { QaqcPipePipesize } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';
import { useGetQaqcPipePipesize } from '../../../../hooks/genericHooks';

const QaqcPipePipesizeEdit: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { record?: QaqcPipePipesize } };
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipePipesize | undefined>(state?.record);
  const { data: sizesResp } = useGetQaqcPipePipesize();

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_pipesize', 'id', id);
        const row = Array.isArray((res as any)?.data) ? (res as any).data[0] : (Array.isArray(res) ? (res as any)[0] : undefined);
        if (row) setRecord(row as QaqcPipePipesize);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate('/qaqc/piping/tools/pipesizes');

  const sizeOptions = useMemo(() => {
    const rows: QaqcPipePipesize[] = (sizesResp?.data as any) || [];
    return rows.map(s => ({ value: s.id, label: `${s.pipesize_name} — ${s.pipesize_inch}`, rec: s }))
      .sort((a,b)=>String(a.label).localeCompare(String(b.label)));
  }, [sizesResp]);

  const missingId = !record && !(params.id && Number.isFinite(Number(params.id)));

  return (
    <>
      {missingId && (
        <Card size="small" title={<Typography.Text strong>Select a pipe size to edit</Typography.Text>}>
          <Select
            showSearch
            allowClear
            placeholder="Search pipe size"
            style={{ width: 420 }}
            options={sizeOptions}
            optionFilterProp="label"
            filterOption={(input, option) => {
              const label = String(option?.label || '').toLowerCase();
              const tokens = input.trim().toLowerCase().split(/\s+/).filter(Boolean);
              return tokens.every(t => label.includes(t));
            }}
            onChange={(val, opt: any) => {
              const id = Number(val);
              const rec = opt?.rec as QaqcPipePipesize | undefined;
              if (Number.isFinite(id)) {
                if (rec) setRecord(rec);
                navigate(`/qaqc/piping/tools/pipesizes/edit/${id}`, { state: { record: rec } });
              }
            }}
          />
        </Card>
      )}
      <QaqcPipePipesizeCreate
        mode="edit"
        initialValues={record}
        onSaved={goBack}
        onCancel={goBack}
        onBack={goBack}
      />
    </>
  );
};

export default QaqcPipePipesizeEdit;
